import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
    UserPasswordReset,
    UserPasswordResetRequest,
} from 'app/modules/shared/classes/user-password-reset';
import { LoginModel } from '../../login/models/login.model';

@Injectable({
    providedIn: 'root',
})
export class ResetPasswordService {
    private url = `https://${window.location.host}/api/v0.5/authentication`;

    constructor(private http: HttpClient) {}
    //post = start; put = finish

    completePasswordReset(
        username: string,
        newPassword: string,
        passwordResetToken: string
    ): Observable<any> {
        return this.http.put<UserPasswordReset>(`${this.url}/ResetPassword`, {
            username: username,
            newPassword: newPassword,
            passwordResetToken: passwordResetToken,
        });
    }

    completeWelcomeEmailReset(
        username: string,
        newPassword: string,
        passwordResetToken: string
    ): Observable<any> {
        return this.http.put<UserPasswordReset>(`${this.url}/CreatePassword`, {
            username: username,
            newPassword: newPassword,
            passwordResetToken: passwordResetToken,
        });
    }

    requestPasswordReset(username: string): Observable<any> {
        return this.http.post<UserPasswordResetRequest>(`${this.url}/ResetPassword`, {
            username: username,
        });
    }
}
